<template>
  <b-modal ref="modal" :hideFooter="true" :hideHeader="true" size="lg" @hidden="onHide">
    <div class="row">
      <div class="col-12" v-if="user">
        <div class="row">
          <div class="col-2 offset-3">
            <img :src="user.photo" class="img-fluid avatar" align="right">
          </div>
          <div class="col-3">
            <span class="user-name">{{ user.name }}</span><br>
            <small>{{ user.tagline }}</small>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-6">
            <label>User</label>
            <v-select
              v-model="user"
              :options="allUsers"
              label="name"
              @blur="$v.user.$touch()"
            ></v-select>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12 m-form m-form--state">
            <form @submit.prevent="submit">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>Date</label>
                    <date-picker
                      @dateSelected="selectedDate = $event"
                      :dateFormat="'dd M yyyy'"
                      :defaultDate="selectedDate"
                      @blur="$v.selectedDate.$touch()"></date-picker>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label style="display: block">Deadline</label>
                    <datetime-picker
                      @blur="$v.deadline.$touch()"
                      v-model="deadline"
                      type="datetime"
                      :first-day-of-week="1"
                      :time-picker-options="{start: '07:00',step: '00:30',end: '19:00'}"
                      :customFormatter="dateFormatter"
                      lang="en"
                      style="width: 100%"
                      @input="val => {deadlineChange(val)}"
                      ref="deadlineSelector"
                    ></datetime-picker>
                  </div>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-6">
                  <label>Client</label>
                  <v-select
                    v-model="client"
                    :options="allClients"
                    label="name"
                    @input="onClientSelect"
                    @blur="$v.client.$touch()"
                    :disabled="hasParent"
                  ></v-select>
                </div>

                <div class="col-6">
                  <div class="form-group m-0">
                    <label>PROJECT</label>
                    <v-select
                      :disabled="!client || hasParent"
                      v-model="project"
                      :options="clientProjects"
                      label="name"
                      @option:created="addNewProject"
                      @blur="$v.project.$touch()"
                      :taggable="true"
                    ></v-select>
                  </div>
                  <span @click="copyProjectName()">
                    <span class="m-link m-link--state m-link--brand" style="cursor:pointer;" v-show="!copied">Copy</span>
                    <span class="m--font-success" style="cursor:pointer;" v-show="copied">Copied!</span>
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>Duration</label>
                    <duration-picker
                      :default="duration"
                      @durationPicked="duration = $event"></duration-picker>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label>Fixed price</label>
                    <input type="number"
                           class="form-control"
                           v-model="fixedPrice"
                           v-if="!isSimple">
                    <input type="text" class="form-control" value="-" :disabled="true" v-if="isSimple">
                  </div>
                </div>
              </div>

              <div class="row mb-2" v-if="!isSimple && billedAt">
                <div class="col-6">
                  <div class="form-group">
                    <label>Billed at</label>
                    <date-picker
                      @dateSelected="billedAt = $event"
                      :dateFormat="'dd M yyyy'"
                      :defaultDate="billedAt"
                      @blur="$v.billedAt.$touch()"></date-picker>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="notes">Notes</label>
                    <textarea name="notes" id="notes" class="form-control" rows="10" v-model="notes"></textarea>
                  </div>
                </div>
              </div>

              <div class="text-center mt-3">
                <button class="btn btn-success mr-1 custom-button" type="submit" :disabled="$v.$invalid || !duration">{{ createMode ? 'ADD' : 'EDIT' }} BOOKING</button>
                <a class="btn btn-default custom-button" @click="$refs.modal.hide()">CANCEL</a>
              </div>

            </form>
          </div>
        </div>
      </div>
      <div ref="copyContainer"></div>
    </div>
  </b-modal>
</template>

<script>
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import DatePicker from '../../components/partials/Datepicker.vue'
  import DurationPicker from '../../components/partials/DurationPicker.vue'
  import DatetimePicker from 'vue2-datepicker'

  import moment from 'moment'
  import {required} from 'vuelidate/lib/validators'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      'b-modal': bModal,
      'date-picker': DatePicker,
      'duration-picker': DurationPicker,
      'datetime-picker': DatetimePicker
    },
    data() {
      return {
        date: null,
        user_id: null,
        task_id: null,
        createMode: true,
        selectedDate: this.date,
        billedAt: null,
        user: null,
        duration: '1:00',
        fixedPrice: null,
        client: null,
        project: null,
        notes: '',
        deadline: null,
        deadlineCache: false,
        allClients: [],
        allUsers: [],
        clientProjects: [],
        hasParent: false,
        copied: false,
        assigned_user: null,
      }
    },

    computed: {
      ...mapGetters('auth', {
        isSimple: 'isSimple',
        loggedUser: 'user'
      })
    },

    methods: {
      deadlineChange(val) {
        if (!this.deadlineCache) {
          this.deadlineCache = val;
          return;
        }
        let valHours = moment(val).format("HH:mm:ss");
        if (valHours === moment(this.deadlineCache).format('HH:mm:ss')) {
          return;
        }
        this.deadlineCache = val;

        if (moment(val).format("HH:mm:ss") !== '00:00:00') {
          this.$refs.deadlineSelector.closePopup()
        }
      },
      submit() {
        if (!this.project || !this.project.id) {
          this.project = null
        }
        const data = {
          user_id: this.user.id,
          date: this.selectedDate,
          client_id: this.client.id,
          project_id: this.project.id,
          notes: this.notes,
          duration: this.duration ? parseInt(this.duration.split(':')[0]) * 3600 + parseInt(this.duration.split(':')[1]) * 60 : null,
          deadline: this.deadline ? moment(this.deadline).format('YYYY-MM-DD HH:mm:00') : null,
          fixed_price: this.fixedPrice ? this.fixedPrice : null,
          billed_at: this.billedAt
        }

        if (this.createMode) {
          data.createdBy = this.loggedUser.id
          this.axios.post('/tasks', data).then(res => {
            this.$emit('taskCreated', res.data.data)
            this.$root.$emit('create-success', res.data.data)
            this.hide()
          }).catch(error => {
          })
        } else {
          data._method = 'PUT';
          this.axios.post('/tasks/' + this.task_id, data).then(res => {
            this.$emit('taskUpdate', res.data.data)
            this.$root.$emit('update-success', res.data.data)
            this.$root.$emit('load-agenda')
            this.hide()
          }).catch(error => {
          })
        }
      },

      dateFormatter(date) {
        return moment(date).format('MMMM D YYYY, HH:mm')
      },

      hide() {
        this.$refs.modal.hide()
        this.onHide()
      },

      create(user_id, date) {
        this.user_id = parseInt(user_id)
        this.date = date.format('DD MMM YYYY')
        this.selectedDate = date.format('DD MMM YYYY')
        this.getAllClients()
        this.getAllUsers()
        this.getAssignee(this.user_id)
        this.$refs.modal.show()
      },

      edit(task_id) {
        this.task_id = parseInt(task_id)
        this.createMode = false
        this.getAllClients()
        this.getAllUsers()
        this.getTask()
        this.$refs.modal.show()
      },

      getTask() {
        this.axios.get('/tasks/' + this.task_id)
          .then(res => {
            const task = res.data.data
            this.selectedDate = moment(task.date).format('DD MMM YYYY')
            this.getAssignee(task.user_id)
            this.duration = this.$root.secondsToTimestring(task.duration)
            this.client = task.client
            this.clientProjects = task.client.projects
            this.project = task.project
            this.notes = task.notes
            this.deadline = task.deadline ? moment(task.deadline) : null
            this.fixedPrice = task.fixed_price
            this.hasParent = task.parent_id ? true : false
            this.billedAt = task.billed_at ? moment(task.billed_at).format('DD MMM YYYY') : null
          })
      },
      getAllUsers() {
        this.axios.get('/users?remove_hidden=true')
          .then(res => this.allUsers = res.data.data)
          .catch(error => {
          })
      },
      getAssignee(id) {
        this.axios.get('/users/' + id)
          .then(res => this.user = res.data.data)
          .catch(error => {
          })
      },
      getAllClients() {
        this.axios.get('/clients')
          .then(res => this.allClients = res.data.data)
          .catch(error => {
          })
      },
      onClientSelect(client) {
        if (this.client === null) {
          this.project = null
          return
        }

        this.clientProjects = client.projects

        // check if selected project belongs to client
        // if not clear field
        if (this.client !== null && this.project !== null) {
          if (!client.projects.find(project => project.id === this.project.id)) {
            this.project = null
          }
        }
      },
      addNewProject(project) {
        const projectName = project instanceof Object ? project.name : project
        const data = {
          name: projectName,
          client_id: this.client.id
        }
        this.axios.post('/projects', data).then(res => {
          if (res.data !== 'EXISTS') {
            const project = res.data.data
            this.clientProjects.push(project)
            this.project = project
          } else {
            this.project = null
            this.$awn.alert('Project already exists!')
          }
        }).catch(error => {
          this.project = null
        })
      },
      onHide() {
        this.createMode = true
        this.selectedDate = this.date
        this.user = null
        this.duration = '1:00'
        this.client = null
        this.project = null
        this.notes = ''
        this.deadline = null
        this.allClients = []
        this.clientProjects = []
        this.fixedPrice = null
        this.hasParent = false
        this.billedAt = null
      },
      copyProjectName() {
        if (!this.project) {
          return
        }
        let container = this.$refs.copyContainer
        this.$copyText(this.project.name, container).then((e) => {
          this.copied = true
          setTimeout(() => {
            this.copied = false
          }, 1000)
        }, (e) => {
          alert('Couldn\'t copy')
        })
      }

    },

    validations: {
      selectedDate: {
        required
      },
      deadline: {
        required
      },
      client: {
        required,
      },
      project: {
        required
      }
    }
  }
</script>

<style scoped>

  button[disabled] {
    cursor: not-allowed;
  }

  @media (max-width: 576px) {

    .custom-button {
      width: auto !important;
    }
  }

  .custom-button {
    width: 20%;
    border-radius: 5%;
  }

  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }

  .user-name {
    font-weight: bold;
  }

  .v-select .dropdown-toggle {
    display: flex !important;
    flex-wrap: wrap;
  }

  .v-select input[type=search], .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    height: 33px;
    padding: 0 20px 0 10px;
    width: 100% !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/agenda/CreateTask.vue